const translation = {
  general: {
    minute_one: '{{ count }}分钟',
    minute_other: '{{ count }}分钟',
    hour_one: '{{ count }}小时',
    hour_other: '{{ count }}小时',
  },
  app: {
    exit: '离开',
    close: '关闭',
    footer: 'Powered by One Click Go Live Limited',
    'login-btn': '登入',
    'logout-btn': '登出',
    confirm: '确认',
  },
  login: {
    title: '用户登入',
    'email-label': '输入电邮',
    'not-registered-remark': '如还未有注册用户，请输入电邮地址并点击以下「确认」按钮',
    'otp-guide-title': '验证码已发送',
    'otp-label': '输入您的一次性验证码',
    'otp-remark-1': '我们已将您的一次性验证码发送到以下电邮地址',
    'otp-remark-2': '请于 15 分钟内完成登入步骤',
    'next-step': '下一步',
    'email-error': '电邮不正确，请重新登入',
    'unknown-error': '错误，请重新登入',
    'otp-error': '验证码不正确，请重新输入',
    'otp-fatal-error': '验证码超时或验证码错误超过3次，请重新登入',
  },
  home: {
    title: '首页',
  },
  event: {
    info: '详情',
    'q-and-a': '问答',
    question: {
      placeholder: '设有问答环节，如您有任何提问，请在这里输入。',
      submit: '提交',
      'succeed-message': '感谢您的提问',
      'failed-message': '提交失败，请稍后再试',
      'exceeds-char-limit-message': '最多可以输入100个中文字（200字符）',
    },
    chatroom: '聊天室',
    polling: '投票',
    si: {
      english: '英语',
      cantonese: '粤语',
      putonghua: '普通话',
    },
    playback: {
      'error-title': '播放失败',
      'error-message': '也许您的网络不太稳定，或者您并没有权限观看此视频',
    },
    'just-started': '刚刚开始',
    'started-ago': '{{age}}前开始',
    'concurrent-error-message': '您已经在其他设备登入',
    'connection-error-message': '网络不稳定',
    'require-login-message': '如果您有权限观看此视频，请刷新',
    'session-kicked-error-message': '您已經在其他設備登入，点击以下按钮在这设备观看',
    'view-here': '在此观看',
    unauthorized: '未授权观看',
  },
  passcode: {
    label: '请输入密码',
    enter: '确定',
    remark: '如未能取得密码，请联络您的活动主办单位查询',
    error: '密码不正确',
    'select-placeholder': '请选择',
  },
  registration: {
    title: '以对话迈向和平与繁荣之路',
    'intro-1':
      '国际调解院（IOMed）是全球首个以条约为基础、专门透过调解解决国际争端的政府间组织，总部位于中国香港特别行政区。',
    'intro-2':
      '在此首届IOMed全球系列活动中，香港特别行政区前后任律政司司长林定国资深大律师及袁国强资深大律师，将分享多年来支持调解的政策与法例发展的幕后故事，包括对成立国际调解院的支持。香港特别行政区所走过的道路，展示调解作为其核心特质之一，可为和平解决争端提供可行而务实的替代方案，为这个充满挑战的世界带来和平与繁荣。',
    'event-details': '活动详情',
    'date-key': '日期',
    'time-key': '时间',
    'venue-key': '地点',
    'address-key': '地址',
    'language-key': '语言',
    'agenda-key': '议程',
    'speakers-key': '讲者',
    'format-key': '形式',
    date: '2026年9月24日（星期四）',
    time: '下午6时至7时30分（香港时间）',
    'time-1': '上午9:30 – 下午12:40（早上9时开始登记）',
    'time-2': '下午12:40 – 下午2:30（交流午餐）',
    venue: '国际调解院总部',
    address: '香港湾仔告士打道123号（旧湾仔警署）',
    language: '英语或普通话（设即时人工智能屏幕翻译）',
    agenda: '按<0>此</0>查看详情',
    speakers: '按<0>此</0>查看详情',
    'virtual-date': '2025年3月4日（星期二）',
    'virtual-time': '上午10:00至下午12:30（香港时间）',
    'virtual-format': '线上',
    'form-heading': '登记',
    'form-attendance-type': '出席形式',
    'attendance-physical': '实体',
    'attendance-online': '线上',
    'form-title': '称谓',
    'form-first-name': '名字',
    'form-last-name': '姓氏',
    'form-job-title': '职位',
    'form-company': '公司／机构',
    'form-email': '电子邮件',
    'form-membership-number': '香港律师会会员编号（如适用）',
    'form-jurisdiction': '司法管辖区',
    'form-agree-pics': '本人已阅读并同意<0>个人资料收集声明</0>。',
    'form-agree-photo': '本人已阅读并同意<0>活动照片及／或影片使用声明</0>。',
    'form-agree-terms':
      '本人已阅读并同意主办单位上述<0>条款及细则</0>，并声明以上资料正确无误。本人知悉所提供的个人资料将作为主办单位的联络资料。',
    'form-agree-marketing':
      '本人同意订阅国际调解院电邮通讯，并同意收取国际调解院的最新消息、新闻及其他市场推广通讯。本人亦同意经选定的第三方合作伙伴将本人的个人资料用于市场推广用途。',
    copyright: '版权所有 © 国际调解院，保留所有权利',
    'pics-url': 'https://event.oneclickgolive.com/external/iomed/20260924/pics-en.pdf',
    'photo-url':
      'https://event.oneclickgolive.com/external/iomed/20260924/statement-of-use-photo-en.pdf',
    'terms-url': 'https://event.oneclickgolive.com/external/iomed/20260924/tnc-en.pdf',
    'data-protection-email': 'Data-protection@investhk.gov.hk',
    submit: '提交',
    'submit-succeed': '提交成功',
    'submit-failed': '提交失败',
    'submit-failed-email': '提交失败\n此电子邮件地址已注册',
    'please-select': '请选择',
    'title-prof': '教授',
    'title-dr': '博士',
    'title-mr': '先生',
    'title-mrs': '夫人',
    'title-ms': '女士',
    'title-miss': '小姐',
    'title-others': '其他',
    'error-attendance-type': '请选择出席形式',
    'error-title': '请选择您的称谓',
    'error-email': '请输入您的电子邮件地址',
    'error-first-name': '请输入您的名字',
    'error-last-name': '请输入您的姓氏',
    'error-company': '请输入您的公司',
    'error-jurisdiction': '请选择司法管辖区',
    'error-agree-pics': '请接受个人资料收集声明',
    'error-agree-photo': '请接受活动照片及／或影片使用声明',
    'error-agree-terms': '请接受条款及细则',
  },
};

export default translation;
